import $ from 'jquery'

// Starts : setMaxHeight
try {

  function setMaxHeight() {

    if ($('.photo-edit  #preview').length > 0) {      
      var previewDom = $('.photo-edit  #preview')
      var previewHeight = $(previewDom).height()
      var previewImage = $('.photo-edit  #preview img.asset')
      $(previewImage).css('max-height', 'none')
      $(previewImage).css('width')
      var previewImageHeight = $(previewImage).height()

      // if frame selected, reduced the max-height
      if ($(previewDom).hasClass('frame')) {
        previewHeight = previewHeight - 14 - 14
        if ($(previewDom).hasClass('polaroid')) {
          previewHeight = previewHeight - 58 + 14
        }
      }

      if (previewImageHeight > previewHeight) {
        $(previewImage).css('max-height', previewHeight)
        $(previewImage).css('width', 'auto')
      } else {
        $(previewImage).css('max-height', 'none')
        $(previewImage).css('width')
      }

      // previewImageHeight = $(previewImage).height()
      // var previewImageWidth = $(previewImage).width()
      // if (
      //   window._STYLES &&
      //   (window._STYLES.rotate === 90 || window._STYLES.rotate === -90)
      // ) {
      //   $(previewImage).css('max-height', 'auto')
      //   $(previewImage).css('height', previewImageWidth)
      //   $(previewImage).css('max-width', previewImageHeight)
      //   $(previewImage).css('width')
      // }
    }
    
  }

  window._UPDATEPREVIEWIMAGEHEIGHT = setMaxHeight

  $(function () {
    setMaxHeight()
  })
  
} catch (err) {
  console.log('Error from' + err.message)
}
// End : setMaxHeight
